import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { int16_type, list_type, option_type, uint8_type, union_type, class_type, int32_type, record_type, string_type, bool_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class ValidateContractsDTO extends Record {
    constructor(AllContractTypes, ContractTypeCode, CreditCheck, PayedInvoices, PhysicalContractApproval, MonthlyValueInRange, AgeInRange, ContractKind) {
        super();
        this.AllContractTypes = AllContractTypes;
        this.ContractTypeCode = ContractTypeCode;
        this.CreditCheck = CreditCheck;
        this.PayedInvoices = PayedInvoices;
        this.PhysicalContractApproval = PhysicalContractApproval;
        this.MonthlyValueInRange = MonthlyValueInRange;
        this.AgeInRange = AgeInRange;
        this.ContractKind = ContractKind;
    }
}

export function ValidateContractsDTO$reflection() {
    return record_type("Containers.MortgageSettings.Model.ValidateContractsDTO", [], ValidateContractsDTO, () => [["AllContractTypes", bool_type], ["ContractTypeCode", string_type], ["CreditCheck", bool_type], ["PayedInvoices", bool_type], ["PhysicalContractApproval", bool_type], ["MonthlyValueInRange", bool_type], ["AgeInRange", bool_type], ["ContractKind", string_type]]);
}

export class ContractTypeMortgage extends Record {
    constructor(ContractTypeMortgageId, Name, RequireCreditCheck, TrafficIsAlternativeToPayedInvoices, RequiredNumberOfPayedInvoices, FeeMin, FeeMax, AgeMin, AgeMax, RequirePhysicalContract) {
        super();
        this.ContractTypeMortgageId = (ContractTypeMortgageId | 0);
        this.Name = Name;
        this.RequireCreditCheck = RequireCreditCheck;
        this.TrafficIsAlternativeToPayedInvoices = TrafficIsAlternativeToPayedInvoices;
        this.RequiredNumberOfPayedInvoices = (RequiredNumberOfPayedInvoices | 0);
        this.FeeMin = FeeMin;
        this.FeeMax = FeeMax;
        this.AgeMin = (AgeMin | 0);
        this.AgeMax = (AgeMax | 0);
        this.RequirePhysicalContract = RequirePhysicalContract;
    }
}

export function ContractTypeMortgage$reflection() {
    return record_type("Containers.MortgageSettings.Model.ContractTypeMortgage", [], ContractTypeMortgage, () => [["ContractTypeMortgageId", int32_type], ["Name", string_type], ["RequireCreditCheck", bool_type], ["TrafficIsAlternativeToPayedInvoices", bool_type], ["RequiredNumberOfPayedInvoices", int32_type], ["FeeMin", class_type("System.Decimal")], ["FeeMax", class_type("System.Decimal")], ["AgeMin", int32_type], ["AgeMax", int32_type], ["RequirePhysicalContract", bool_type]]);
}

export class SelectedContractTypeMortgage extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Existing", "CreateNew", "Nothing"];
    }
}

export function SelectedContractTypeMortgage$reflection() {
    return union_type("Containers.MortgageSettings.Model.SelectedContractTypeMortgage", [], SelectedContractTypeMortgage, () => [[["Item", int32_type]], [], []]);
}

export class ContractValuationSetting extends Record {
    constructor(ContractValuationId, Key, Value, Index) {
        super();
        this.ContractValuationId = ContractValuationId;
        this.Key = Key;
        this.Value = Value;
        this.Index = Index;
    }
}

export function ContractValuationSetting$reflection() {
    return record_type("Containers.MortgageSettings.Model.ContractValuationSetting", [], ContractValuationSetting, () => [["ContractValuationId", uint8_type], ["Key", string_type], ["Value", string_type], ["Index", option_type(string_type)]]);
}

export class ContractValuation extends Record {
    constructor(ContractValuationId, Description) {
        super();
        this.ContractValuationId = ContractValuationId;
        this.Description = Description;
    }
}

export function ContractValuation$reflection() {
    return record_type("Containers.MortgageSettings.Model.ContractValuation", [], ContractValuation, () => [["ContractValuationId", uint8_type], ["Description", string_type]]);
}

export class ContractValuationSettingResponse extends Record {
    constructor(ContractValuationSettings, ContractValuationIds) {
        super();
        this.ContractValuationSettings = ContractValuationSettings;
        this.ContractValuationIds = ContractValuationIds;
    }
}

export function ContractValuationSettingResponse$reflection() {
    return record_type("Containers.MortgageSettings.Model.ContractValuationSettingResponse", [], ContractValuationSettingResponse, () => [["ContractValuationSettings", list_type(ContractValuationSetting$reflection())], ["ContractValuationIds", list_type(ContractValuation$reflection())]]);
}

export class ContractValuationSettingFields extends Record {
    constructor(ContractValuationId, Key, Value) {
        super();
        this.ContractValuationId = ContractValuationId;
        this.Key = Key;
        this.Value = Value;
    }
}

export function ContractValuationSettingFields$reflection() {
    return record_type("Containers.MortgageSettings.Model.ContractValuationSettingFields", [], ContractValuationSettingFields, () => [["ContractValuationId", string_type], ["Key", string_type], ["Value", string_type]]);
}

export class ContractTypeValuationSettingResponseDTO extends Record {
    constructor(Display, ContractTypeCode, ContractTypeMortgageId, ContractTypeMortgageName, ContractValuationId, ContractValuationDescription, MaxBoundMonths, AddBoundMonths, Active) {
        super();
        this.Display = Display;
        this.ContractTypeCode = ContractTypeCode;
        this.ContractTypeMortgageId = ContractTypeMortgageId;
        this.ContractTypeMortgageName = ContractTypeMortgageName;
        this.ContractValuationId = ContractValuationId;
        this.ContractValuationDescription = ContractValuationDescription;
        this.MaxBoundMonths = MaxBoundMonths;
        this.AddBoundMonths = AddBoundMonths;
        this.Active = Active;
    }
}

export function ContractTypeValuationSettingResponseDTO$reflection() {
    return record_type("Containers.MortgageSettings.Model.ContractTypeValuationSettingResponseDTO", [], ContractTypeValuationSettingResponseDTO, () => [["Display", string_type], ["ContractTypeCode", string_type], ["ContractTypeMortgageId", option_type(int16_type)], ["ContractTypeMortgageName", option_type(string_type)], ["ContractValuationId", option_type(uint8_type)], ["ContractValuationDescription", option_type(string_type)], ["MaxBoundMonths", string_type], ["AddBoundMonths", string_type], ["Active", bool_type]]);
}

export class ContractTypeValuationSettingResponse extends Record {
    constructor(Display, ContractTypeCode, ContractTypeMortgageId, ContractTypeMortgageName, ContractValuationId, ContractValuationDescription, MaxBoundMonths, AddBoundMonths, Active, Index) {
        super();
        this.Display = Display;
        this.ContractTypeCode = ContractTypeCode;
        this.ContractTypeMortgageId = ContractTypeMortgageId;
        this.ContractTypeMortgageName = ContractTypeMortgageName;
        this.ContractValuationId = ContractValuationId;
        this.ContractValuationDescription = ContractValuationDescription;
        this.MaxBoundMonths = MaxBoundMonths;
        this.AddBoundMonths = AddBoundMonths;
        this.Active = Active;
        this.Index = Index;
    }
}

export function ContractTypeValuationSettingResponse$reflection() {
    return record_type("Containers.MortgageSettings.Model.ContractTypeValuationSettingResponse", [], ContractTypeValuationSettingResponse, () => [["Display", string_type], ["ContractTypeCode", string_type], ["ContractTypeMortgageId", option_type(int16_type)], ["ContractTypeMortgageName", option_type(string_type)], ["ContractValuationId", option_type(uint8_type)], ["ContractValuationDescription", option_type(string_type)], ["MaxBoundMonths", string_type], ["AddBoundMonths", string_type], ["Active", bool_type], ["Index", string_type]]);
}

